var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBrown3X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check_brown@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_brown",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(2.000000, 2.000000)",
    fill: "#875610",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,10.5 C8.03756612,10.5 10.5,8.03756612 10.5,5 C10.5,1.96243388 8.03756612,-0.5 5,-0.5 C1.96243388,-0.5 -0.5,1.96243388 -0.5,5 C-0.5,8.03756612 1.96243388,10.5 5,10.5 Z M5,9.5 C2.51471863,9.5 0.5,7.48528137 0.5,5 C0.5,2.51471863 2.51471863,0.5 5,0.5 C7.48528137,0.5 9.5,2.51471863 9.5,5 C9.5,7.48528137 7.48528137,9.5 5,9.5 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55416749,2 L5.55416749,4.35506094 C5.55416749,4.60484138 5.53931616,4.84981468 5.50961304,5.08998818 C5.47990992,5.33016168 5.44030635,5.58474177 5.39080116,5.85373609 L4.56406848,5.85373609 C4.51456328,5.58474177 4.47495972,5.33016168 4.4452566,5.08998818 C4.41555348,4.84981468 4.40070215,4.60484138 4.40070215,4.35506094 L4.40070215,2 L5.55416749,2 Z M4.21258333,7.2845787 C4.21258333,7.18600905 4.23156004,7.0922103 4.26951403,7.00317965 C4.30746801,6.914149 4.36027276,6.83783816 4.42792987,6.77424483 C4.49558697,6.71065151 4.57561917,6.65977762 4.66802888,6.62162162 C4.76043858,6.58346563 4.85944749,6.56438792 4.96505858,6.56438792 C5.06736932,6.56438792 5.16472809,6.58346563 5.25713779,6.62162162 C5.34954749,6.65977762 5.42875462,6.71065151 5.49476155,6.77424483 C5.56076848,6.83783816 5.61357323,6.914149 5.65317739,7.00317965 C5.69278155,7.0922103 5.71258333,7.18600905 5.71258333,7.2845787 C5.71258333,7.38632801 5.69278155,7.48092166 5.65317739,7.56836248 C5.61357323,7.6558033 5.56076848,7.73131924 5.49476155,7.79491256 C5.42875462,7.85850588 5.34954749,7.90858487 5.25713779,7.94515103 C5.16472809,7.98171719 5.06736932,8 4.96505858,8 C4.85944749,8 4.76043858,7.98171719 4.66802888,7.94515103 C4.57561917,7.90858487 4.49558697,7.85850588 4.42792987,7.79491256 C4.36027276,7.73131924 4.30746801,7.6558033 4.26951403,7.56836248 C4.23156004,7.48092166 4.21258333,7.38632801 4.21258333,7.2845787 Z",
    id: "!"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBrown3X);
export default __webpack_public_path__ + "static/media/check_brown@3x.5d101df8c9c72f324cacfea453120700.svg";
export { ForwardRef as ReactComponent };